import React from 'react';
import * as PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core';
import RefreshIconButton from '../../buttons/components/RefreshIconButton';
import TextInput from '../../form/components/TextInput';

const useStyles = makeStyles({
    container: {
        width: '100%',
    },

    select: {
        width: `calc(100% - 100px)`,
    },

    switch: {
        width: 100,
    },
});

const MailDraftFilterPanel = () => {
    const classes = useStyles();
    const { submitForm } = useFormikContext();

    return (
        <Grid container direction="row" wrap="wrap" spacing={2} className={classes.container}>
            <Grid item xs={10} className={classes.select}>
                <TextInput name="filterByText" fullWidth label="Text Suche" />
            </Grid>
            <Grid item xs={2} className={classes.select}>
                <RefreshIconButton onClick={submitForm} />
            </Grid>
        </Grid>
    );
};

MailDraftFilterPanel.propTypes = {
    customerId: PropTypes.number,
};

MailDraftFilterPanel.defaultProps = {
    customerId: 0,
};

export default MailDraftFilterPanel;
